(ns frontend.ui.page.fund.investor-references.sub
  (:require
   [frontend.ui.page.fund.investor-references.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub ::status
            (fn [db [_ owner-id]] (model/status db owner-id)))
